<template>
    <div>
        <mobile-naigation />

        <v-flex-container center stretch>
            <v-card-container>
                <v-card>
                    <div v-padding.xs.top="3" v-padding.xs.bottom="1" v-padding.md.left="7" v-padding.md.right="7"
                        v-padding.xs.left="2" v-padding.xs.right="2" v-text-align.center>
                        <v-text>
                            Зарегистрируйтесь и получите все <br /> инструменты
                            для проверки клиента
                        </v-text>
                    </div>
                    <div v-padding.md.left="8" v-padding.md.right="8" v-padding.xs.left="2" v-padding.xs.right="2">
                        <register-form />
                    </div>
                </v-card>
            </v-card-container>
        </v-flex-container>

        <div v-text-align.center v-margin.top="3">
            <v-text>
                Уже зарегистрированы?

                <v-router-link :to="{ name: 'login' }">
                    Войти в личный кабинет
                </v-router-link>
            </v-text>
        </div>
    </div>
</template>
<script>
import MobileNaigation from '../MobileNaigation';
import RegisterForm from './RegisterFormContainer';
import {
    vCard, vCardContainer,
    vFlexContainer,
} from '../baseComponents';

export default {
    name: 'register',
    components: {
        vCard,
        vCardContainer,
        vFlexContainer,
        RegisterForm,
        MobileNaigation,
    },
}
</script>



// WEBPACK FOOTER //
// Register.vue?35ce25bc